import { DateTime } from 'luxon'
import { FC } from '../../Services/FeathersClient'
import { invalidateQuery } from '../../Services/QueryCache'

export const createNewAgency = async (agency, loggedInUser) => {
  let isErroring = false
  try {
    // Crea una nuova agenzia
    await FC.service('agencies').create(agency)
    window.growl.show({
      severity: 'success',
      summary: 'Creazione nuova agenzia',
      detail: 'Agenzia creata correttamente.'
    })
  } catch (error) {
    console.error('Errore durante la creazione dell\'agenzia:', error)
    window.growl.show({
      severity: 'error',
      summary: 'Errore',
      detail: 'Creazione dell\'agenzia non riuscita: ' + error.message
    })
    isErroring = true
  }
  try {
    const defaultFilters = [
      { path: 'C:\\Boffice', fileNameFiltersToExclude: [], fileExtensionsToInclude: ['mir', 'MIR', 'CN*'], localSilentBlacklist: [], forwardingRules: [], inclusionRegex: { regex: '.*\\.(mir|MIR|CN.*)$', flags: '' }, docType: 'MIR', backupPath: 'C:\\copiatkt\\' },
      { path: 'C:\\spl', fileNameFiltersToExclude: [], fileExtensionsToInclude: ['PNR', 'pnr', 'FIL'], localSilentBlacklist: [], forwardingRules: [], inclusionRegex: { regex: '.*\\.(PNR|pnr|FIL)$', flags: '' }, docType: 'SBR', backupPath: 'C:\\copiatkt\\' },
      { path: 'C:\\Air', fileNameFiltersToExclude: [], fileExtensionsToInclude: ['M01', 'M02', 'M03', 'M04', 'M05', 'M06', 'M07', 'M08', 'M09', 'M10', 'M11', 'M12', 'm01', 'm02', 'm03', 'm04', 'm05', 'm06', 'm07', 'm08', 'm09', 'm10', 'm11', 'm12', 'tkt' ], localSilentBlacklist: [], forwardingRules: [], inclusionRegex: { regex: '.*\\.(m|M)(\\d{1,2})(\\d{1,2})$', flags: '' }, docType: 'AMA', backupPath: 'C:\\copiatkt\\' },
      { path: 'C:\\Pico', fileNameFiltersToExclude: [], fileExtensionsToInclude: ['xml', 'XML'], localSilentBlacklist: [], forwardingRules: [], inclusionRegex: { regex: '.*\\.(xml|XML)$', flags: '' }, docType: 'PIC', backupPath: 'C:\\copiatkt\\' },
      { path: 'C:\\NTV', fileNameFiltersToExclude: [], fileExtensionsToInclude: ['xml', 'XML'], localSilentBlacklist: [], forwardingRules: [], inclusionRegex: { regex: '.*\\.(xml|XML)$', flags: '' }, docType: 'NTV', backupPath: 'C:\\copiatkt\\' }
    ]
    await FC.service('configs').create({
      agencyId: agency._id,
      name: 'default',
      lastEditedBy: loggedInUser,
      lastEdited: DateTime.now().toISO(),
      createdBy: loggedInUser,
      createdAt: DateTime.now().toISO(),
      filters: defaultFilters,
      isDeleted: false
    })
    invalidateQuery('configs')
  } catch (err) {
    console.error('Errore durante la creazione dell\'configurazione:', err)
    window.growl.show({
      severity: 'error',
      summary: 'Errore',
      detail: 'Creazione della configurazione non riuscita.'
    })
    isErroring = true
  }
  if (isErroring) {
    return false
  }
  return true
}
